import { useController, UseControllerProps } from 'react-hook-form'
import useReactHookFormError from './useReactHookFormError'
import { ISelectorProps, Selector } from './Inputs/Selector'

export type TOption = {
    label: any
    value: any
    key?: any
    groupKey?: string
}

function OWSelect<T extends object>(
    props: ISelectorProps & UseControllerProps<T>,
) {
    const {
        name,
        control,
        rules,
        onChange: customOnChange,
        value: customValue,
        ...selectProps
    } = props

    const {
        field,
        formState: { errors },
    } = useController<T>({ name, control, rules })

    const error = useReactHookFormError(errors, name)

    const { ref, onChange, ...otherFields } = field

    return (
        <Selector
            {...selectProps}
            {...otherFields}
            value={
                //prevent not found value warning when the option is loading or updating
                selectProps.options?.length === 0 ||
                !selectProps.options.some(
                    (o) => o.value === (customValue ?? field.value),
                )
                    ? ''
                    : customValue ?? field.value
            }
            inputRef={ref}
            onChange={customOnChange || onChange}
            error={error.error}
            helperText={error.helperText}
        />
    )
}

export default OWSelect
